import { FeatureFlagConfigService } from '../../../feature-flags/feature-flag-config-service';
import { initFeatureFlags } from '../../../feature-flags/redux/init';
import { getLaunchDarklyFeatureFlags, getOptions } from '../../../feature-flags/config';
import { LogService } from '../../../services/log-service';

export const launchDarklyInit = () => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const injectedProfile = FeatureFlagConfigService.buildUserConfigFromBootstrap();

      const launchDarklyFeatureFlags = getLaunchDarklyFeatureFlags();
      let bootstrap;
      if (launchDarklyFeatureFlags?.length) {
        try {
          const decodedFlags = atob(launchDarklyFeatureFlags);
          bootstrap = JSON.parse(decodedFlags);
        } catch (error) {
          LogService.logInfo('Failed to parse bootstrap feature flags', error);
        }
      }

      if (!injectedProfile || !bootstrap) {
        // if it has failed we need to get the user information to fall back
        resolve({
          bootstrapFailed: true,
        });
        return;
      }
      await initFeatureFlags({
        user: injectedProfile,
        ldOptions: getOptions({ bootstrap }),
        isBootstrapped: true,
      });

      resolve({});
    } catch (e) {
      reject(e);
    }
  });
};
